// Web shim for react-native-localize
// 在 Web 上使用浏览器 API 获取语言信息

export const getLocales = (): Array<{ languageCode: string; countryCode?: string }> => {
  if (typeof window === 'undefined' || !window.navigator) {
    return [{ languageCode: 'en' }];
  }

  const language = window.navigator.language || window.navigator.languages?.[0] || 'en';
  const parts = language.split('-');
  
  return [{
    languageCode: parts[0] || 'en',
    countryCode: parts[1],
  }];
};

export const getCountry = (): string => {
  if (typeof window === 'undefined' || !window.navigator) {
    return 'US';
  }
  const locale = window.navigator.language || 'en-US';
  const parts = locale.split('-');
  return parts[1] || 'US';
};

export const getCurrencies = (): string[] => {
  // Web 环境下返回默认货币
  return ['USD'];
};

export const getTimeZone = (): string => {
  if (typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  return 'UTC';
};

export const uses24HourClock = (): boolean => {
  if (typeof window === 'undefined' || !window.navigator) {
    return false;
  }
  // 简单判断：检查系统时间格式
  const date = new Date();
  const timeString = date.toLocaleTimeString();
  return !timeString.includes('AM') && !timeString.includes('PM');
};

export const usesMetricSystem = (): boolean => {
  // 大多数国家使用公制，除了美国等少数国家
  const country = getCountry();
  return country !== 'US' && country !== 'LR' && country !== 'MM';
};

export default {
  getLocales,
  getCountry,
  getCurrencies,
  getTimeZone,
  uses24HourClock,
  usesMetricSystem,
};
